module.exports = __webpack_public_path__ + "static/website-launch-3fbfc4df818c7fbe6258d0fd824a79e5.jpg";